import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "target"]

  connect() {
    this.updateTarget()

    this.observer = new MutationObserver(() => this.updateTarget())
    this.observer.observe(this.sourceTarget, {
      characterData: true,
      childList: true,
      subtree: true
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  updateTarget() {
    const value = parseFloat(this.sourceTarget.textContent) || 0
    const targetValue = parseFloat(this.targetTarget.dataset.value)
    this.targetTarget.textContent = (targetValue + value * 0.1).toFixed(2)
    if (this.targetTarget.textContent >= 100) {
      this.targetTarget.classList.add("text-green-600")
    } else {
      this.targetTarget.classList.remove("text-green-600")
    }
  }
}